import { mxgraphInstance } from './mxgraphFactory';

/**
 * IO
 */
// export const mxCellCodec = mxgraphInstance.mxCellCodec;
// export const mxChildChangeCodec = mxgraphInstance.mxChildChangeCodec;
export const mxCodec = mxgraphInstance.mxCodec;
export const mxCodecRegistry = mxgraphInstance.mxCodecRegistry;
// export const mxDefaultKeyHandlerCodec = mxgraphInstance.mxDefaultKeyHandlerCodec;
// export const mxDefaultPopupMenuCodec = mxgraphInstance.mxDefaultPopupMenuCodec;
export const mxDefaultToolbarCodec = mxgraphInstance.mxDefaultToolbarCodec;
// export const mxEditorCodec = mxgraphInstance.mxEditorCodec;
export const mxGenericChangeCodec = mxgraphInstance.mxGenericChangeCodec;
// export const mxGraphCodec = mxgraphInstance.mxGraphCodec;
// export const mxGraphViewCodec = mxgraphInstance.mxGraphViewCodec;
// export const mxModelCodec = mxgraphInstance.mxModelCodec;
export const mxObjectCodec = mxgraphInstance.mxObjectCodec;
// export const mxRootChangeCodec = mxgraphInstance.mxRootChangeCodec;
export const mxStylesheetCodec = mxgraphInstance.mxStylesheetCodec;
// export const mxTerminalChangeCodec = mxgraphInstance.mxTerminalChangeCodec;

// 重写decode方法以获取引用模块中的类
mxgraphInstance.mxCodec.prototype.decode = function (node, into) {
    this.updateElements();
    let obj = null;

    if (node != null && node.nodeType == mxgraphInstance.mxConstants.NODETYPE_ELEMENT) {
        let ctor = null;

        try {
            ctor = window[node.nodeName] || mxgraphInstance[node.nodeName] || (eval(`new ${node.nodeName}()`).constructor);
        }
        catch (err) {
            // ignore
        }

        let dec = mxCodecRegistry.getCodec(ctor);

        if (dec != null) {
            obj = dec.decode(this, node, into);
        }
        else {
            obj = node.cloneNode(true);
            obj.removeAttribute('as');
        }
    }

    return obj;
};